// VillageContext.js
import React, { createContext, useState, useEffect } from 'react';

export const VillageContext = createContext();

export const VillageProvider = ({ children }) => {
  const [selectedVillageId, setSelectedVillageId] = useState(() => {
    return localStorage.getItem('VillageId') || '';
  });

  useEffect(() => {
    localStorage.setItem('VillageId', selectedVillageId);
  }, [selectedVillageId]);
  
  return (
    <VillageContext.Provider value={{ selectedVillageId, setSelectedVillageId }}>
      {children}
    </VillageContext.Provider>
  );
};
  